import { Box, Typography } from "@mui/material";
export function getLayoutLead(v, s) {
  return (
    <Box
      sx={{
        mx: "auto",
        p: `6rem 10%`,
        maxWidth: "1300px",
        backgroundColor: "white",
      }}
    >
      <Typography
        variant="body1"
        fontFamily="Lato-Regular"
        lineHeight={1.75}
        sx={{
          ...s,
          color: (theme) => theme.palette.grey[700],
          "& span": {
            fontFamily: "Lato-Bold",
            color: (theme) => theme.palette.grey[800],
          },
        }}
      >
        {v}
      </Typography>
    </Box>
  );
}
